export default "__VITE_ASSET__DPGKK7e5__"